<template>
      <div >
        <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
        <br/>
        <span style="color:#909399;font-size: 13px; margin-left: 50px;">{{$t('analyse.accountDataTable.updateTime')}} {{time}}</span>
        <div style="margin: 70px">
          <el-tag type="success" style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:25px">{{depositAccount}}</span><p>{{$t('analyse.depositTable.amountAccount')}}</p></el-tag>
          <el-tag  style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:25px">{{withdrawalAccount}}</span><p>{{$t('analyse.poorTable.withdrawalAccount')}}</p></el-tag>
          <el-tag type="warning" style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:12px">{{depositAmount}}</span><p>{{$t('analyse.depositTable.depositAmount')}}</p></el-tag>
          <el-tag type="danger" style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:12px">{{withdrawalAmount}}</span><p>{{$t('analyse.poorTable.withdrawalAmount')}}</p></el-tag>
          <el-tag type="info" style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:12px">{{poorAmount}}</span><p>{{$t('analyse.poorTable.poorAmount')}}</p></el-tag>
        </div>
        <div style=" margin-left: 1130px;">
          <el-button id="dayBut" @click="dayBut"  :type="type==1 ? 'success':'primary'" >{{$t('analyse.accountDataTable.day')}}</el-button>
          <el-button id="weekBut" @click="weekBut" :type="type==2 ? 'success':'primary'" :disabled="weekBy">{{$t('analyse.accountDataTable.weekBy')}}</el-button>
          <el-button id="monthBut" @click="monthBut" :type="type==3 ? 'success':'primary'" :disabled="monthBy">{{$t('analyse.accountDataTable.monthBy')}}</el-button>
        </div>
        <div id="main" style="width:90%; height: 700px"></div>

        <br/>
        <span style="color:#909399;font-size: 15px; font-weight: bold; margin-left: 50px;">{{$t('analyse.accountDataTable.detail')}}</span>
        <el-button type="primary" style="float:right;"  @click="exportData()" v-auth="'analyse:chshoutPoor:export'">{{$t('analyse.accountDataTable.export')}}</el-button>
        <el-table  :data="tableData" style="width: 100%;margin-left: 70px;"  :default-sort = "{prop: 'date', order: 'descending'}">
          <el-table-column  prop="time"  :label="$t('analyse.accountDataTable.date')"  sortable  />
          <el-table-column  prop="depositMoney"  :label="$t('analyse.depositTable.depositAmount')"  sortable/>
          <el-table-column  prop="withdrawalMoney"  :label="$t('analyse.poorTable.withdrawalAmount')"  sortable/>
          <el-table-column  prop="poorMoney"  :label="$t('analyse.poorTable.poorAmount')"  sortable/>
        </el-table>
      </div>

</template>

<script>
  //存款平台
  let outChannels={};
    //table封装组件
    import URL from '@/views/analyse/util/url'
    import FORM from '@/components/page/form.vue'
    import download from '@/utils/download'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    import echarts from 'echarts'
    export default {
        components: {
            FORM
        },
        data() {
            return {
                // drawLineOption:{},
                tableData:{},
                cakeOption:{},
                time:'',
                type:1,
                withdrawalAccount:0,
                depositAccount:0,
                withdrawalAmount:"",
                depositAmount:"",
                poorAmount:"",
                weekBy:true,
                monthBy:true,
                formData:{
                    cols:[
                        { title: window.$t("analyse.poorTable.time"), field: 'time',type:6,change:(data,col)=>{
                                if(data.time!=null){
                                    let startTime=data.timeStart;
                                    let endTime=data.timeEnd;
                                    let day=(endTime-startTime)/(24*60*60*1000);
                                    if(day>7){
                                        this.weekBy=false;
                                    }else{
                                        this.weekBy=true;
                                    }
                                    if(this.getMonthCount(startTime,endTime)>=1){
                                        this.monthBy=false;
                                    }else{
                                        this.monthBy=true;
                                    }
                                }

                            }},
                        { title: window.$t("analyse.depositTable.inChannel"), field: 'outChannel',type:2,optionList:outChannels},
                        {click:window.$t("common.search"),auth:'analyse:chshoutPoor:sel'}
                    ]
                },

            }
        },
        mounted(){
            this.$axios.get(URL.chshoutAnalyseVn.getPoorData).then(res => {
                if (res.code == 0) {
                    this.outChannels=res.result.outChannels;
                    this.formData.cols =[
                        { title: window.$t("analyse.poorTable.time"), field: 'time',type:6,change:(data,col)=>{
                                if(data.time!=null){
                                    let startTime=data.timeStart;
                                    let endTime=data.timeEnd;
                                    let day=(endTime-startTime)/(24*60*60*1000);
                                    if(day>7){
                                        this.weekBy=false;
                                    }else{
                                        this.weekBy=true;
                                    }
                                    if(this.getMonthCount(startTime,endTime)>=1){
                                        this.monthBy=false;
                                    }else{
                                        this.monthBy=true;
                                    }
                                }

                            }},
                        { title: window.$t("analyse.depositTable.inChannel"), field: 'outChannel',type:2,optionList:this.outChannels},
                        {click:window.$t("common.search"),auth:'analyse:chshoutPoor:sel'}
                    ];
                }
            });
        },
        methods: {
            checkbox(row){
                this.deleteIds = row.map(key => key.id).join(",");
            },
            dayBut(){
                this.type=1;
                let data={};
                data.timeStart=null;
                data.timeEnd=null;
                if(this.formData.cols[0].data!=undefined){
                    data.timeStart=this.formData.cols[0].data[0];
                    data.timeEnd=this.formData.cols[0].data[1];
                }
                data.outChannel=this.formData.cols[1].data;
                this.getWithdrawal(1,data);
            },
            weekBut(){
                this.type=2;
                let data={};
                data.timeStart=null;
                data.timeEnd=null;
                if(this.formData.cols[0].data!=undefined){
                    data.timeStart=this.formData.cols[0].data[0];
                    data.timeEnd=this.formData.cols[0].data[1];
                }
                data.outChannel=this.formData.cols[1].data;
                this.getWithdrawal(2,data);
            },
            monthBut(){
                this.type=3;
                let data={};
                data.timeStart=null;
                data.timeEnd=null;
                if(this.formData.cols[0].data!=undefined){
                    data.timeStart=this.formData.cols[0].data[0];
                    data.timeEnd=this.formData.cols[0].data[1];
                }
                data.outChannel=this.formData.cols[1].data;
                this.getWithdrawal(3,data);
            },
            exportData(){
                let startTime=null;
                let endTime=null;
                if(this.formData.cols[0].data!=undefined){
                  startTime=this.formData.cols[0].data[0];
                  endTime=this.formData.cols[0].data[1];
                }
                let outChannel=this.formData.cols[1].data;
                if((startTime!=undefined && endTime!=undefined) ||outChannel!=undefined) {
                    if (outChannel == undefined)
                        outChannel = "";
                    if (startTime == undefined)
                        startTime = null;
                    if (endTime == undefined)
                        endTime = null;
                    let urlLast = "";
                    if (startTime != null && endTime != null) {
                        urlLast = "&startTime=" + startTime + "&endTime=" + endTime;
                        download.exportExcel(URL.chshoutAnalyseVn.poorExport + "?outChannel=" + outChannel+urlLast, {}, "充提差信息");
                    } else {
                        download.exportExcel(URL.chshoutAnalyseVn.poorExport, {}, "充提差信息");
                    }
                }else {
                    download.exportExcel(URL.chshoutAnalyseVn.poorExport, {}, "充提差信息");
                }
            },
            //折线图
            drawLine(id,drawLineOption) {
                this.charts = echarts.init(document.getElementById(id));
                // console.log(JSON.stringify(drawLineOption));
                // 指定图表的配置项和数据
                // var option = {
                //     tooltip: {              //设置tip提示
                //         trigger: 'axis'
                //     },
                //     legend: {               //设置区分（哪条线属于什么）
                //         data: ['real', 'demo', 'activity']
                //     },
                //     color: ['#96CDCD', '#8AE09F', '#FA6F53'],       //设置区分（每条线是什么颜色，和 legend 一一对应）
                //     xAxis: {                //设置x轴
                //
                //         type: 'category',
                //         boundaryGap: false,     //坐标轴两边不留白
                //         data: ['2019-1-1', '2019-2-1', '2019-3-1', '2019-4-1', '2019-5-1', '2019-6-1', '2019-7-1',],
                //         // nameTextStyle: {        //坐标轴名称的文字样式
                //         //     color: '#FA6F53',
                //         //     fontSize: 16,
                //         //     padding: [0, 0, 0, 20]
                //         // }
                //         // axisLine: {             //坐标轴轴线相关设置。
                //         //     lineStyle: {
                //         //         color: '#FA6F53',
                //         //     }
                //         // }
                //     },
                //     yAxis: {
                //         name: '近7日用户增长趋势',
                //         nameTextStyle: {
                //             // color: '#FA6F53',
                //             fontSize: 13,
                //             padding: [0, 0, 10, 0]
                //         },
                //
                //         type: 'value'
                //     },
                //     series: [
                //         {
                //             name: 'real',
                //             data: [420, 200, 150, 20, 70, 110, 130],
                //             type: 'line',
                //             lineStyle: {
                //                 normal: {
                //                     color: '#96CDCD',
                //                 }
                //             },
                //         }, {
                //             name: 'demo',
                //             data: [220, 232, 201, 234, 290, 230, 220],
                //             type: 'line',               // 类型为折线图
                //             lineStyle: {                // 线条样式 => 必须使用normal属性
                //                 normal: {
                //                     color: '#8AE09F',
                //                 }
                //             },
                //         },
                //         {
                //             name: 'activity',
                //             data: [120, 200, 150, 80, 70, 110, 130],
                //             type: 'line',
                //             lineStyle: {
                //                 normal: {
                //                     color: '#FA6F53',
                //                 }
                //             },
                //         }
                //     ]
                // };
                this.charts.setOption(drawLineOption);
            },
            //饼图1
            drawCake1(id,cakeOption){
                this.charts = echarts.init(document.getElementById(id));
                // var option = {
                //     title: {
                //         text: '渠道来源分布',
                //         // subtext: '纯属虚构',
                //         left: 'center'
                //     },
                //     tooltip: {
                //         trigger: 'item',
                //         formatter: '{a} <br/>{b} : {c} ({d}%)'
                //     },
                //     legend: {
                //         orient: 'vertical',
                //         left: 'left',
                //         data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                //     },
                //     series: [
                //         {
                //             name: '访问来源',
                //             type: 'pie',
                //             radius: '55%',
                //             center: ['50%', '60%'],
                //             data: [
                //                 {value: 335, name: '直接访问'},
                //                 {value: 310, name: '邮件营销'},
                //                 {value: 234, name: '联盟广告'},
                //                 {value: 135, name: '视频广告'},
                //                 {value: 1548, name: '搜索引擎'}
                //             ],
                //             emphasis: {
                //                 itemStyle: {
                //                     shadowBlur: 10,
                //                     shadowOffsetX: 0,
                //                     shadowColor: 'rgba(0, 0, 0, 0.5)'
                //                 }
                //             }
                //         }
                //     ]
                // };
                this.charts.setOption(cakeOption);
            }, /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(clickName == "查询" || window.$t("common.search") == clickName){
                    this.getWithdrawal(1,data);
                }
            },
            getWithdrawal(type,data){
                if((data.timeStart!=undefined && data.timeEnd!=undefined)||data.outChannel!=undefined) {
                    if (data.outChannel == undefined)
                        data.outChannel = "";
                    if(data.timeStart==undefined)
                        data.timeStart=null;
                    if(data.timeEnd==undefined)
                        data.timeEnd=null;
                    let urlLast="";
                    if(data.timeStart!=null && data.timeEnd !=null){
                        urlLast="&startTime=" + data.timeStart + "&endTime=" +  data.timeEnd;
                    }
                    this.$axios.get(URL.chshoutAnalyseVn.poor + "?outChannel=" + data.outChannel +"&type="+type+urlLast).then(res => {
                        if (res.code == 0) {
                            let brokenLine=res.result.brokenLine;
                            this.time=res.result.time;
                            this.withdrawalAccount=res.result.withdrawalAccount;
                            this.depositAccount=res.result.depositAccount;
                            this.withdrawalAmount=res.result.withdrawalAmount;
                            this.depositAmount=res.result.depositAmount;
                            this.poorAmount=res.result.poorAmount;
                            this.tableData=res.result.details;
                            this.$nextTick(function() {
                                this.drawLine('main',brokenLine);
                            });
                        }
                    });
                }else{
                    this.$axios.get(URL.chshoutAnalyseVn.poor+"?type="+type).then(res => {
                        if (res.code == 0) {
                            let brokenLine=res.result.brokenLine;
                            this.time=res.result.time;
                            this.withdrawalAccount=res.result.withdrawalAccount;
                            this.depositAccount=res.result.depositAccount;
                            this.withdrawalAmount=res.result.withdrawalAmount;
                            this.depositAmount=res.result.depositAmount;
                            this.poorAmount=res.result.poorAmount;
                            this.tableData=res.result.details;
                            this.$nextTick(function() {
                                this.drawLine('main',brokenLine);
                            });
                            this.$nextTick(function() {
                                this.drawCake1('cake1',cake1);
                            });
                            this.$nextTick(function() {
                                this.drawCake1('cake2',cake2);
                            });
                        }
                    });
                }
            },
            getMonthCount(startTime,endTime){
                let date2=this.fromDate(startTime);
                let date1=this.fromDate(endTime);
                date1 = date1.split('-');
                // 得到4102月数1653
                date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
                // 拆分年月日
                date2 = date2.split('-');
                // 得到月数
                date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
                return Math.abs(date1 - date2);
            },fromDate(date){
                date = new Date(date);
                let YY = date.getFullYear() + '-';
                let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
                return YY + MM + DD;
            }

        }
    }
</script>
